import React, { useState, useEffect, useRef } from 'react';
import { SketchPicker } from 'react-color';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Box, Button, Switch, FormControlLabel, Typography, Grid, Chip} from '@mui/material';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import '../App.css';
import { alpha, styled } from '@mui/material/styles';
import { saveImage } from '../imageStorageHandling';
import { image } from '@nextui-org/react';

function DesignsComponent(props) {
  const [userInput, setUserInput] = useState('');
  //const [background, setBackground] = useState('#EDEDED');
  const [mainColor, setMainColor] = useState('');
  //const [showBackgroundPicker, setShowBackgroundPicker] = useState(false);
  //const [showMainPicker, setShowMainPicker] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [removeBg, setRemoveBg] = useState(false);
  const [upscale, setUpscale] = useState(false);
  const [generatedImage, setGeneratedImage] = useState(null);
  //const backgroundPickerRef = useRef(null);
  //const mainPickerRef = useRef(null);
  const [dummy, setDummy] = useState('');
  const [tempImage, setTempImage] = useState('');
  const hasRun = useRef(false);
  const [temp, setTemp] = useState('');
  const [image_url_to_mockups, setUrlMockup] = useState('');
  const [prompt_to_mockups, setPromptMockup] = useState('');
  const [dalle_image, setDalleImage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); 
  const hasFirst = useRef(false);
  const [imageNoBg, setImageNoBg] = useState(null); // State for image without background
  const [selectedImage, setSelectedImage] = useState(null);

  const handleGenerate = async () => {
    setLoading(true);
    const data = {
      userInput,
      selectedCategory, //: selectedCategory ? selectedCategory.id : null,
      mainColor,
    };
  
    try {
      const response = await axios.post(process.env.REACT_APP_API_ENDPOINT, data);
      
      if (response.status === 200) {
        console.log('Data sent successfully');
        await saveImage(response.data.image_url);
        setUrlMockup(response.data.image_url);
        setPromptMockup(response.data.prompt);
        
        // Only setGeneratedImage here; do not toggle removeBg
        setGeneratedImage(response.data.image_url);
        setDalleImage(response.data.image_url);
        // Reset the removeBg and imageNoBg states to default
        setRemoveBg(false);
        setImageNoBg(null);
        setSelectedImage(removeBg ? imageNoBg : response.data.image_url);
      } else {
        console.error('Failed to send data to the server');
      }
    } catch (error) {
      console.error('Error sending data to the server:', error);
      setError(error);
    } finally {
      setLoading(false); // End loading
    }
  };

  useEffect(() => {
    if (props.initialDesignData) {
      // Here, set your local state based on the initialDesignData
      setUserInput(props.initialDesignData.prompt);
      setMainColor(props.initialDesignData.main_color);
      setSelectedCategory(props.initialDesignData.style);
      setDummy("dummy");

      
    }
  }, [props.initialDesignData]);

   useEffect(() => {
    // BUG IS FIXED
    if (!hasRun.current && userInput !== '') {
      handleGenerate();
      hasRun.current = true; 
    }
  }, [dummy]);



  const stylesOptions = [
    { label: '3D Model', id: '3D_Model' },
    { label: 'Analog', id: 'Analog' },
    { label: 'Anime', id: 'Anime' },
    { label: 'Comic Book', id: 'Comic_Book' },
    { label: 'Cyberpunk', id: 'Cyberpunk' },
    { label: 'Digital Art', id: 'Digital_Art' },
    { label: 'Fantasy Art', id: 'Fantasy_Art' },
    { label: 'Line Art', id: 'Line_Art' },
    { label: 'Origami', id: 'Origami' },
    { label: 'Synthwave', id: 'Synthwave' },
    { label: 'Photorealistic', id: 'Photorealistic' },
    { label: 'Pixel Art', id: 'Pixel_Art' },
  ];

  const colorOptions = [
    { label: 'Red', id: 'red' },
    { label: 'White', id: 'white' },
    { label: 'Black', id: 'black' },
    { label: 'Blue', id: 'blue' },
    { label: 'Green', id: 'green' },
    { label: 'Yellow', id: 'yellow' },
    { label: 'Orange', id: 'orange' },
    { label: 'Purple', id: 'purple' },
    { label: 'Grey', id: 'grey' },
    { label: 'Brown', id: 'brown' },
    { label: 'Pink', id: 'pink' },
    { label: 'Cyan', id: 'cyan' },
    { label: 'Magenta', id: 'magenta' }
];



  const removeBackground = async () => {
    if (!generatedImage) {
      console.log("No image to process");
      return;
    }
  
    setLoading(true);
  
    try {
      let imageUrl = generatedImage; // Default to the currently generated image
      if (!removeBg) {
        // If removeBg is currently false, we want to remove the background.
        
        const response = await axios.post(process.env.REACT_APP_REMOVE_BACKGROUND, {
          image_url: generatedImage,
        });
        console.log(response);
        if (response.status === 200 && response.data.remove_bg_img) {
          setImageNoBg(response.data.remove_bg_img); // Save no background image
          imageUrl = response.data.remove_bg_img; // Update imageUrl to the no background image
        } else {
          console.error('Background removal failed');
        }
      }
      // Toggle the removeBg state regardless of the outcome to reflect the user's intent
      setRemoveBg(current => !current);
      setSelectedImage(imageUrl); // Set selectedImage based on the current action
    } catch (error) {
      console.error('Error removing background:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const CustomSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: '#ff4c15ff',
      '&:hover': {
        backgroundColor: alpha('#ff4c15ff', theme.palette.action.hoverOpacity), // Adjust hover opacity as needed
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#ff4c15ff',
    },
  }));
  

  
  return (
    <Grid container spacing={2} sx={{ p: 2, justifyContent: 'center' }}>
      <Grid item xs={3} md={3} sx={{ display: 'flex', flexDirection: 'column', gap: 5, border: '2px solid #F5F5F5', padding: '20px', borderRadius: '10px', marginTop: '20px' }}>
        <TextField
          placeholder="Prompt"
          variant="outlined"
          size="large"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#F5F5F5',
              '& fieldset': {
                borderColor: 'transparent',
              },
              '&:hover fieldset': {
                borderColor: 'transparent',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'transparent',
              },
            },
          }}
        />
  
        <Autocomplete
          disablePortal
          id="style-autocomplete"
          options={stylesOptions}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#F5F5F5',
              '& fieldset': {
                borderColor: 'transparent',
              },
              '&:hover fieldset': {
                borderColor: 'transparent',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'transparent',
              },
            },
          }}
          value={selectedCategory}
          onChange={(event, newValue) => {
            setSelectedCategory(newValue);
          }}
          renderInput={(params) => <TextField {...params} placeholder="Style" size="large" />}
        />

      <Autocomplete
          disablePortal
          id="color-autocomplete"
          options={colorOptions}
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#F5F5F5',
              '& fieldset': {
                borderColor: 'transparent',
              },
              '&:hover fieldset': {
                borderColor: 'transparent',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'transparent',
              },
            },
          }}
          value={mainColor}
          onChange={(event, newValue) => {
            setMainColor(newValue);
          }}
          renderInput={(params) => <TextField {...params} placeholder="Color" size="large" />}
        />
  
        
  
        <FormControlLabel
          control={<CustomSwitch checked={removeBg} onChange={removeBackground} />}
          disabled={loading} // This disables the switch when loading is true
          label="Remove Background"
        />
  
        {/* Generate Button */}
        <Button
          variant="contained"
          startIcon={<AutoAwesomeRoundedIcon />}
          onClick={handleGenerate}
          disabled={loading} // This disables the button when loading is true
          sx={{
            width: '100%',
            height: '50px',
            backgroundColor: loading ? '#cccccc' : '#ff4c15ff', // Optional: Change color when disabled
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: loading ? '#cccccc' : '#e2400f', // Prevent hover effect when disabled
            },
            borderRadius: '10px',
          }}
        >
          Generate
        </Button>
      </Grid>
  
      <Grid item xs={9} md={9} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start' }}>
        {loading ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <img src={'/logo.png'} alt="Loading..." className="dancingImage" />
            <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
              Cooking up designs...
            </Typography>
          </Box>
        ) : generatedImage ? (
          <Box sx={{ width: '60%', height: 'auto', borderRadius: '50px', overflow: 'hidden' }}>
          <img src={selectedImage} alt="Generated Design" style={{ width: '100%', height: '100%', objectFit: 'cover'}} />
        </Box>
      ) : null}

      {selectedImage && (
        <Button
          variant="contained"
          endIcon={<ArrowForwardIosIcon />}
          onClick={() => props.onChangeToMockups({
            image_url_to_mockups: selectedImage, // This now relies on accurate state management
            prompt_to_mockups,
            dalle_image: selectedImage // Ditto
          })}
          sx={{
            position: 'fixed',
            right: '100px',
            bottom: '50px',
            height: '50px',
            mt: 2,
            backgroundColor: '#ff4c15ff',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: '#e2400f',
            },
            borderRadius: '10px',
          }}
        >
          Next
        </Button>
      )}

    </Grid>
  </Grid>
);}
  
        
  

export default DesignsComponent;